import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, IconButton, Snackbar, Tooltip, Typography } from '@material-ui/core';
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DragNDropUploader } from "../../componentes/DragNDrop/DragNDropUploader";
import { useState } from "react";
import { ImageUploadCard } from "../../componentes/DragNDrop/ImageUploadCard";
import { FaInfo, FaInfoCircle } from "react-icons/fa";
import service from "./NfeImportService";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { Alert } from "@mui/material";

const initialState = {
    success: false,
    error: false,
    message: ""
}

export default function NfeImport() {
    const { t } = useTranslation();
    const userId = sessionStorage.getItem("userId");
    const [state, setState] = useState(initialState);
    const { success, error, message } = state;
    const endPoint = "FileReader/uploadXML";
    const [open, setOpen] = useState(false);
    function setSuccess(success, message) {
        setState({ success: success, message: message });
    }


    function setError(error, message) {
        setState({ error: error, message: message });
    }

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    }

    const uploadCallBack = args => {
        const formData = new FormData();
        formData.append("file", args.file.rawFile);

        service
            .imp(formData, userId)
            .then((response) => {
                if (response.status === 200) {
                    setSuccess(true, t("saveSuccess"));
                }
            })
            .catch((e) => {
                setError(true, t("saveError"))
            });
    };

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="nfeImport"
                fields={
                    <>
                        <GridItemContainer>
                        <Snackbar open={open} autoHideDuration={6000} onClose={closeAlert} anchorOrigin={{ verticalAlign: 'top', horizontalAlign: 'center' }} key={'top' + 'center'}>
                                        <Alert onClose={closeAlert} severity="error" sx={{ width: '100%' }}>
                                            {t("extensionNotAllowed")}
                                        </Alert>
                                    </Snackbar>
                            <CustomAlert
                                success={success}
                                message={message}
                                snackbar
                                autoClose
                            />
                            <GridInputRow>
                                <Grid item xs={6} md={6}>
                                    <Tooltip
                                        title={
                                            <Typography>
                                                {t("dragFileToUpload")}
                                            </Typography>
                                        }
                                    >
                                        <IconButton style={{ marginLeft: "150px" }}>
                                            <FaInfoCircle color="#29438D" />
                                        </IconButton>
                                    </Tooltip>
                                    <ImageUploadCard
                                        open={(e) => setOpen(e)}
                                        uploadCallBack={uploadCallBack}
                                        cantRemove
                                        isRegister={true}
                                        marginBottom
                                    //endPoint={endPoint}
                                    />
                                </Grid>
                            </GridInputRow>
                        </GridItemContainer>
                    </>
                }
            />
        </>
    );
};
